/**
 * @description add name redux at here!!
 */
export enum SearchFilterTypes {
	NOTICE = 'commonNotice',
	NOTICE_RECEIVE = 'commonNoticeReceive',
	INQUIRY_BOARD = 'commonInquiryBoard',
	INQUIRY_BOARD_ANSWER = 'commonInquiryBoardAnswer',
	UM1_01 = 'systemUser',
	AR1_01 = 'workerApplicant',
	MM1_01 = 'workerUser',
	LM1_01 = 'workerLodging',
	RM1_01 = 'workerRecommender',
	AM1_01 = 'workerAssignmentFranchise',
	AM3_01 = 'workerAssignment',
	PA1_01 = 'workerAssignmentPublic',
	PA4_01 = 'workerSalary',
	FR1_01 = 'workerFranchise',
	BM1_01 = 'workerUnauthorizedDeparture',
	DM1_01 = 'workerDocument',
	PM1_01 = 'workerProgram',
	PM2_01 = 'workerProgramStatus',
	CM1_01 = 'systemUnit',
	WC1_01 = 'workerChangeWorkPlace',
	EM1_01 = 'workerExtensionStay',
	MSLP = 'mSelectLodgingPopup',
	OI2_01 = 'foreignUser',
	OR1_01 = 'foreignApplicant',
	OP1_01 = 'foreignProgram',
	CM2_01 = 'foreignSystemUnit',
	ST1_01 = 'workerUseTip',
	SM1_01 = 'systemUseTip',
	PA3_01 = 'workerPublicSalary',
	AU1_01 = 'workerAuditMonitoring',
	DEV_01 = 'deviceMobile',
	DEV_03 = 'deviceTablet',
	DEV_08 = 'deviceLog',
}
